/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Carousel } from "antd";
import { Container, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { get_mentor_profile_data_action, logout_user_action } from "../../../redux/_actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";

export default () => {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onHomeClick = () => {
    navigate("/mentor");
  };

  const onSubmitClick = async () => {
    if (user?.user_details && user.user_details?.is_verified) {
      navigate("/dashboard");
    } else navigate("/mentor-onboard");
  };

  const { mentorProfileData } = useSelector(
    (state) => state.get_mentor_profile_data_reducer
  );

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (mentorProfileData?.data) {
      let data = mentorProfileData?.data;
      const setUserInLocal = async () => {
        let parsedUser = JSON.parse(localStorage.getItem("jigsawUser"));
        parsedUser = { ...parsedUser, user: data?.user_details };
        await localStorage.setItem("jigsawUser", JSON.stringify(parsedUser));
      };
      setUserInLocal();
      setUser(data);
    }
  }, [mentorProfileData]);

  const callApi = async () => {
    await dispatch(get_mentor_profile_data_action());
  };
  const onSignOutClick = async () => {
    setLoading(true);
    const user_token =
      (await localStorage.getItem("jigsawUser")) &&
      JSON.parse(localStorage.getItem("jigsawUser"));
    const refreshToken = user_token?.refresh_token;
    await dispatch(logout_user_action({ refresh: refreshToken }));
    window.location.reload();
  };

  return (
    <div className="common-login role-selection-wrapper">
      <Container className="px-0">
        <div className="row no-gutters">
          <div className="col-lg-6   d-none d-md-block">
            <div className="left-img">
              <div className="login-slider">
                <Carousel autoplay arrows>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-1.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Simplify Your Recruitment Process
                    </h2>
                    <p className="font-weight-medium text-white mb-5">
                      Make recruitment easy for businesses of all sizes.
                      Streamline your hiring process, from job posting to
                      candidate management, and discover the best-fit candidates
                      for your team with Jigsaw's innovative platform.
                    </p>
                  </div>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-2.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Rescue Hiring Manger & Candidate From Fate
                    </h2>
                    <p className="font-weight-medium text-white mb-5">
                      Don't leave recruitment process of hiring manager and
                      candidate’s career to fate. Take control with Jigsaw's
                      intuitive platform, designed to simplify recruitment and
                      elevate your professional growth. Say goodbye to
                      uncertainty and achieve your goals with Jigsaw.
                    </p>
                  </div>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-3.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Take Control of Your Career with Jigsaw!
                    </h2>
                    <p className="font-weight-medium text-white mb-5">
                      Unlock your full potential and achieve your career goals
                      with Jigsaw. Our intuitive platform empowers you with the
                      tools and resources you need to succeed, streamlined job
                      searching and interview preparation. Take control of your
                      future today with Jigsaw.
                    </p>
                  </div>
                </Carousel>
              </div>
            </div>
          </div>
          <div className="col-lg-6 ">
            <div className="form-wrapper py-5 h-100">
              <ul className="steps d-flex align-items-center justify-content-between mx-auto mb-4">
                <li className="step completed">
                  <span>1</span>
                </li>
                <li className="step completed">
                  <span>2</span>
                </li>
                <li className="step completed">
                  <span>3</span>
                </li>
              </ul>

              <div className="successful-message text-center mt-4 mt-lg-5">
                <img
                  src="../assets/images/onboard-successful.png"
                  alt="onboard-successful"
                />
                <h2 className="mt-3">
                  {user?.user_details && user.user_details?.is_verified
                    ? "Your profile is successfully verified."
                    : "Your Profile is waiting for verification!"}
                </h2>
                <p
                  className="text-muted mt-2 cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    onHomeClick();
                  }}
                >
                  {user?.user_details && user.user_details?.is_verified
                    ? "View next steps"
                    : "View platform details"}
                </p>
              </div>
              <div className="text-center mt-auto py-4">
                <button
                  className="btn btn-primary-outline px-4 text-primary"
                  onClick={onSubmitClick}
                >
                  {user?.user_details && user.user_details?.is_verified
                    ? "Go to Dashboard"
                    : "Update Profile"}
                </button>
                <div className="mt-2">
                  <button
                    onClick={onSignOutClick}
                    className="btn btn-primary d-flex justify-content-center py-2 border-radius-10 mx-auto"
                  >
                    {loading ? (
                      <div className="d-flex justify-content-center align-items-center w-100">
                        <Spinner animation="border" variant="white" />
                      </div>
                    ) : (
                      <p className="mb-0">
                        {" "}
                        Logout
                        <FontAwesomeIcon icon={faSignOut} className="ml-2" />
                      </p>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
